var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../assets/ellafashion.png")}}),_vm._v(" "),_c('v-ons-progress-bar',{attrs:{"indeterminate":"","disable-auto-styling":""}}),_vm._v("\n    Loading...\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95d9852e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SplashPage.vue
// module id = 319
// module chunks = 1